import { NPage } from '@app/components/Page/types/Page.main';
import { BackButton, MenuButton } from '@app/components/Page/ui';

import type { FC } from 'react';

interface NavButtonsProps {
  isMobile: boolean;
  menuSidebarState: NPage.MenuSidebarState;
  onBackClick?: () => void;
  onMenuClick?: () => void;
  // Hides only the back button. The mobile menu toggle stays visible so users
  // always keep a way to open the sidebar on small screens.
  hideBackButton?: boolean;
  mobileTitle?: string;
}

export const NavButtons: FC<NavButtonsProps> = ({
  isMobile,
  onBackClick,
  onMenuClick,
  menuSidebarState = NPage.MenuSidebarState.NONE,
  hideBackButton = false,
  mobileTitle,
}) => {
  if (!isMobile) {
    if (hideBackButton) return null;

    return <BackButton onClick={onBackClick} size={64} />;
  }

  return (
    <div className="mobile-buttons_container">
      <MenuButton
        onClick={onMenuClick}
        menuSidebarState={menuSidebarState}
        isMobile={isMobile}
      />
      {mobileTitle && (
        <span className="mobile-buttons_container__title">{mobileTitle}</span>
      )}
      {!hideBackButton && <BackButton onClick={onBackClick} size={27} />}
    </div>
  );
};
